import { useTranslation } from 'react-i18next';
import { Route, useRouteMatch } from 'react-router';
import { BY_ID, CHECK_USER_STATUS, CREATE_URL, DELETE_PERMISSIONS, EDIT_PERMISSIONS } from '../../../../const/URL.const';
import { DialogRoute } from '../../../dialogRoutes/DialogRoute';

import UnlinkUser from './UnlinkUser';

import AddNewUsers from './AddNewUsers';
import EditUserPermissions from './EditUsers';
import { HTTPMethods } from '../../../../yoello-lib/modules/API/API';
import { ICallAPIFunction } from "../../../../yoello-lib/modules/API2/types";

import { ReactComponent as PermissionIcon } from "../../../../assets/images/lock-permission-icon.svg";
import CheckUserStatus from './CheckUserStatus';

export interface IUserListDialogues {
    users: any[];
    callAPI: Function;
    invitationsListApi: ICallAPIFunction<any>;
    getMerchants:()=>void;
}

const UserListDialogues = ({
    users,
    callAPI,
    invitationsListApi,
    getMerchants
}: IUserListDialogues) => {
    const { t } = useTranslation();
    let { path } = useRouteMatch();


    const onDeleteUser = async (venueId: string, merchantId: string) => {
        return callAPI(HTTPMethods.DELETE, {
            query: `${venueId}/merchants/${merchantId}`,
        }).then(() => {
            getMerchants();
        });
    }

    return (
        <>
            <Route exact path={`${path}/${CREATE_URL}`}>
                <DialogRoute 
                    Component={AddNewUsers}
                    navigateBackRoute={path}
                    dialogTitle={t('user_management.dialog.titleCreate')}
                    ComponentPropsFunctions={{
                        users,
                        invitationsListApi:invitationsListApi
                    }}
                />
            </Route>

            <Route exact path={`${path}${EDIT_PERMISSIONS}${BY_ID}`}>
                <DialogRoute 
                    Component={EditUserPermissions}
                    navigateBackRoute={path}
                    dialogTitle={t('user_management.dialog.titleEdit')}
                    ComponentPropsFunctions={{
                        users,
                    }}
                />
            </Route>

            <Route exact path={`${path}${DELETE_PERMISSIONS}${BY_ID}`}>
                <DialogRoute 
                    Component={(props) => <UnlinkUser {...props} onDeleteUser={onDeleteUser} />}
                    navigateBackRoute={path}
                    dialogTitle={<div style={{marginLeft: "10rem"}}><PermissionIcon /></div>}
                    ComponentPropsFunctions={{
                        users,
                    }}
                />
            </Route>

            <Route exact path={`${path}/${CHECK_USER_STATUS}`}>
                <DialogRoute 
                    Component={CheckUserStatus}
                    navigateBackRoute={path}
                    dialogTitle={t('user_management.dialog.titleCheckUserStatus')}
                    ComponentPropsFunctions={null}
                />
            </Route>
        </>
    )
    
}

export default UserListDialogues;